<style lang="scss" scoped>
    /deep/ .listTable table{
        width: 100% !important;
    }
    /deep/ .listTable table tr th{
        text-align: center !important;
    }
    /deep/ .listTable table tr td{
        text-align: center !important;
    }
    /deep/ .ivu-tag-text{ width: 100%; max-width:70px}
        .textRight{
        /deep/ .ivu-select-selection {
            border-color: rgba(8,244,247, .3);
            background-color: rgba(255,255,255,.1);
            color: #08F4F7;
        }
         /deep/ .ivu-select-dropdown-list{
            background-color: #001a29;
        }
        /deep/ .ivu-select-item-selected, /deep/ .ivu-select-item{
            background-color: #243851;
        }
        /deep/  .ivu-select-item:hover{
          color: #74d9ff;
        }
        /deep/ .ivu-tag{
            background-color: #001a29;
            color: #74d9ff;
            border-color: rgba(8,244,247, .3);
        }
        /deep/ .ivu-icon-ios-close{
            color: #fff;
        }
    }
    
        /deep/ .ivu-select-item{
            color: #b9c0c4;
        }
</style>
<template>
    <div>
        <div class="update_wrap">
            <span>刷新时间: {{lodeTime}}</span>
            <img src="../../assets/img/update_btn.png" @click="refresh" alt="">
        </div>
        <Table :columns="tableColumns" :data="dataList" class="listTable m-t-10"></Table>
        <div class="textRight m-t-10">
            <span class="fLeft lh32">温度对比（°C）</span>
            <Select
                    
                placeholder="请选择组"
                v-model="deviceTypeSid"
                :filterable="deviceList.length > 5" 
                style="width:500px;position: absolute;right:314px;text-align:left" multiple
                @on-change="changeDate"
            >
                <Option v-for="item in deviceList" :value="item.value" :key="item.value">{{ item.label}}</Option>
            </Select>
            <Button type="primary" @click="dataConversion(oldData,'1')" class="m-l-10" style="position: absolute;right:244px;text-align:left">搜索</Button>
            <RadioGroup v-model="day" @on-change="getChart" type="button">
                <Radio label="today">今日</Radio>
                <Radio label="yesterday">昨日</Radio>
            </RadioGroup>
        </div>
        <line-chart class="m-t-10" :id="'line-chart-0'" :height="'240px'" :y="lineData.y" :x="lineData.x" :dateUnit="'year'"  :colorObj="colorObj"></line-chart>
    </div>
</template>
<script>
    import lineChart from '@/components/line.vue';
    import {getDate} from '@/assets/js/index.js';
// 随机字符串
import getRandVal, {getTime} from '@/assets/js/index';
// 加密
import Base64 from '@/assets/js/base64.js';
import md5 from 'js-md5';
    export default {
        name: 'wit-electric-temperature',
        props: {
            id: ''
        },
        data() {
            return {
                day: 'today',
                lineData: {
                    x: [],
                    y: [],
                    // markArea: []
                },
                lodeTime: '',
                tableColumns: [],
                dataList: [],
                loginData: {},
                colorObj:{},
                deviceList:[],
                deviceTypeSid:[],
                temporaryFile:'',
                oldData:{},
            };
        },
        mounted() {
            this.getList();
            this.loginData = JSON.parse(window.localStorage.getItem('loginData'));
        },
        methods: {
             //获取数据开始
            getPwdHash(pwd, data) {
                var sha = md5(pwd + data);
                var base = new Base64();
                var pwdHashStr = base.encode(sha);
                return pwdHashStr;
            },
            changeDate(val) {
                if (val.length > 6) {
                    this.$Message.warning('最多选择6条');
                    this.deviceTypeSid.pop();
                }
            },
            refresh() {
                this.lodeTime = getDate(new Date().getTime(), 'year');
                this.getTable();
            },
            getList() {
                this.refresh();
                this.getTable();
                this.getChart();
            },
            getChart() {            
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/graph/${this.id}`;
                    let _this = this;
                    this.deviceTypeSid = []
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'wd',
                            date:this.day
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            this.deviceList = []
                            
                            this.oldData = res.data.data //存储数据
                            let num = 0
                            for(let value in res.data.data){
                                if(num < 6){
                                    this.deviceTypeSid.push(value)
                                }
                                this.deviceList.push({
                                    value,
                                    label:value
                                }) //过滤名称
                                num ++
                            }
                            this.dataConversion(res.data.data,'0')

                            
                            // this.getOffline(arrX,arrY);
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            dataConversion(val,search){
                let data = []
                if(search == '1'){ //搜索
                    if(this.deviceTypeSid.length == 0){
                        this.$Message.info('请最少选择一条！');
                        return
                    }
                    data = this.deviceTypeSid
                }else{
                    if( Object.keys(val).length > 6 ){
                        for( let key of this.deviceList.slice(0,6)){
                            data.push(key.value)
                        }
                    }else{
                        for( let key of this.deviceList){
                            data.push(key.value)
                        }
                    }
                }
                let arrX = [], arrY = {}, index = 0;

                for (let item of data) {
                    let obj = this.oldData[item];
                    this.colorObj[item] = obj[0].pointTypeCode
                    for (let y = 0; y < obj.length; y++) {
                        if (index === 0) arrX.push(obj[y]['time'].substring(0,obj[y]['time'].length-2) + "00"); //秒数置为“00”
                        if (arrY[item] && arrY[item].length) {
                            arrY[item].push(obj[y]['value'])
                        } else {
                            arrY[item] = [obj[y]['value']];
                        }
                    }
                    if (arrX.length) index = 1;
                }
                this.lineData['x'] = arrX;
                this.lineData['y'] = arrY;
            },
            getTable() {
                return new Promise((resolve, reject) => {
                    let url = `/mcbw/network_monitor/pointNowValue/${this.id}`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'wd',
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            let arr=[],arr1=[],obj = {};
                            res.data.data.map((value,index) => {
                                arr.push({
                                    title: value.pointName+value.unit,
                                    key: `value${index}`,
                                    width: '100%',
                                })
                                obj[`value${index}`] = value.value;
                            })
                            arr1.push(obj);
                            this.tableColumns = arr;
                            this.dataList = arr1;
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
            getOffline(arrX,arrY) {
                let timeType,arr={};
                if(this.day == 'today'){
                    timeType = null
                }else{
                    timeType = this.day
                }

                return new Promise((resolve, reject) => {
                    let url = `/mcbw/off_line/device_part`;
                    let _this = this;
                    var data = {
                        type: 'get',
                        url: url,
                        obj: {
                            orgId: _this.$store.state.baseInfoLayer.baseInfoId,
                            type: 'wd',
                            tId: this.id,
                            cId: JSON.parse(localStorage.getItem('loginData')).orgId, //单位ID
                            date: timeType,
                        }
                    };
                    _this.$Axios(data).then((res) => {
                        if (res) {
                            arr.data = [];
                            res.data.data.forEach(function(value) {
                                let num = 0;
                                for (var index in value){
                                    if(arrX.indexOf(value[index].xAxis) > -1){
                                        num += 1;
                                        if(num == 2){
                                            arr.data.push(value);
                                        }
                                    }
                                }
                            });
                            this.lineData['x'] = arrX;
                            this.lineData['y'] = arrY;
                            this.lineData['markArea'] = arr;
                        }
                        resolve()
                    }).catch(err => {
                        reject(err)
                    })
                })
            },
        },
        watch: {
            id() {
                this.getList()
            }
        },
        components: {
            lineChart
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/wit-electric-monitor/wit-electric-temperature.vue